export default "__VITE_ASSET__D$iO39pq__"